import { request } from '../utils';

export default function baseRequest(root: any, data: any, callBack?) {
    request(root, data).then((rd) => {
        callBack && callBack(rd, rd.errCode, rd.errDesc);
    });
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/operates/baseRequest.ts